import React from "react";
import PropTypes from "prop-types";
import "../css/Splash.css";

/**
 * Splash component
 */
class Splash extends React.Component {
  static displayName = "Splash";
  static propTypes = {
    className: PropTypes.string
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "Splash";
    this.state = {
      show: true
    };
  }

  componentDidMount() {
    const hideIt = () => (this.splash.style.display = "none");

    this.splash.addEventListener("transitionend", hideIt);
  }

  /**
   * @override
   */
  render() {
    return (
      <div
        className={`${this.className} ${this.props.className || ""} ${
          this.state.show ? "show" : "hide"
        }`}
        ref={c => (this.splash = c)}
        onClick={() => this.setState({ show: false })}
      >
        <div className={`${this.className}__close`}>
          <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
            <path
              fill="#000000"
              d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
            />
          </svg>
        </div>
        <div className={`${this.className}__logo`} href="/">
          <div>
            Aeby<br />&<br />Associés<br />
            <br />
            <span className="color">1998</span>
          </div>
          <div>
            Perneger<br />
            <br />SA
            <br />
            <br />
            <span className="color">2018</span>
          </div>
        </div>
      </div>
    );
  }
}

export default Splash;
